import { render, staticRenderFns } from "./arrow-up-outline.vue?vue&type=template&id=b1f845e6&scoped=true&"
import script from "./arrow-up-outline.vue?vue&type=script&lang=js&"
export * from "./arrow-up-outline.vue?vue&type=script&lang=js&"
import style0 from "./arrow-up-outline.vue?vue&type=style&index=0&id=b1f845e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f845e6",
  null
  
)

export default component.exports